import { observer } from 'mobx-react-lite'
import { Scrollbar, TextFieldWithLabel } from 'shared/ui'
import { type ApplicationsStore } from 'pages/settings/pages/developer/pages/applications/store/applicationsStore'
import { ScopeBlock } from 'pages/settings/pages/developer/ui/ScopeBlock/ScopeBlock'
import styles from './styles.module.scss'

type IClientModalContentProps = {
  store: ApplicationsStore
}

export const ClientModalContent = observer(({ store }: IClientModalContentProps) => {
  return (
    <Scrollbar autoHeight autoHeightMax={'524px'}>
      <div className={styles.fields} aria-label='Client form'>
        <TextFieldWithLabel
          marginBottom={'20px'}
          labelProps={{
            label: {
              text: 'Name',
            },
          }}
          limit={191}
          errorMessage={store.clientNameError}
          textFieldProps={{
            value: store.clientName,
            onChange: store.setNewClientName,
            onBlur: store.validateNewClientNameBlur,
            InputProps: {
              placeholder: 'Enter client name',
            },
          }}
        />
        <TextFieldWithLabel
          labelProps={{
            label: {
              text: 'Redirect URL',
            },
          }}
          errorMessage={store.clientRedirectUrlError}
          textFieldProps={{
            value: store.clientRedirectUrl,
            onChange: store.setNewClientRedirectUrl,
            onBlur: store.validateNewClientRedirectUrlBlur,
            InputProps: {
              placeholder: 'https://',
            },
          }}
        />
        <ScopeBlock
          scopes={store.allScopes}
          toggleScope={store.toggleScope}
          selectedScopes={store.selectedScopes}
        />
      </div>
    </Scrollbar>
  )
})
